import gql from 'graphql-tag'

export default gql`
  query getTechpackShare($techpackId: String!) {
    getTechpackShare(id: $techpackId) {
      _id
      companyName
      link
      metadata {
        ContentLength
        ContentType
      }
      techpack {
        _id
        link
        name
        attachments {
          _id
          link
          name
          metadata {
            ContentLength
            ContentType
          }
        }
        product {
          name
          code
          _id
        }
      }
    }
  }
`
